function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;


//////////////////
// WEBPACK FOOTER
// ./~/react-event-listener/~/@babel/runtime/helpers/builtin/assertThisInitialized.js
// module id = ./node_modules/react-event-listener/node_modules/@babel/runtime/helpers/builtin/assertThisInitialized.js
// module chunks = 1